export default __webpack_public_path__ + "static/media/map_animate.1acad8fe.gif";